import { connect } from 'react-redux';
import AppSidebar from './AppSidebar';

const mapStateToProps = state => {
  return {
    client: state.client,
  };
};

export default connect(mapStateToProps)(AppSidebar);
